import { useCallback, useState } from "react";

import { isFalsy } from "@vega-core/utils/isFalsy";

export function useLocaleStorage<T = unknown>(
  keyName: string,
  defaultValue: T,
): [value: T, setValue: (update: T) => void] {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = localStorage.getItem(keyName);

      if (!isFalsy(value)) {
        return JSON.parse(value);
      } else {
        localStorage.setItem(keyName, JSON.stringify(defaultValue));

        return defaultValue;
      }
    } catch (err) {
      console.error(err);

      return defaultValue;
    }
  });

  const setValue = useCallback(
    (newValue: T) => {
      localStorage.setItem(keyName, JSON.stringify(newValue));
      setStoredValue(newValue);
    },
    [keyName],
  );

  return [storedValue, setValue];
}
